/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const DotListIcon = createIcon(
  '0 0 20 20',
  <path d="M3.803 5.613c.996 0 1.803-.809 1.803-1.807a1.803 1.803 0 1 0-3.606 0c0 .998.807 1.807 1.803 1.807m0 12.387c.996 0 1.803-.809 1.803-1.806 0-.998-.807-1.807-1.803-1.807S2 15.196 2 16.193C2 17.192 2.807 18 3.803 18M19 2.774H7.667V4.84H19zM7.667 8.968H19v2.064H7.667zm0 6.193H19v2.065H7.667zM5.606 10c0 .998-.807 1.806-1.803 1.806A1.805 1.805 0 0 1 2 10a1.804 1.804 0 1 1 3.606 0" />,
);
